export function Logo() {
  return (
    <div className="flex gap-x-2 items-center font-medium text-neutral-700 dark:text-neutral-300">
      <div className="size-4">
        <Logo2 />
      </div>
      Chat Upload Portal
    </div>
  );
}

// Modified version of https://www.shadcn.io/icon/streamline-sharp-chat-two-bubbles-oval
export function Logo2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="opacity-100 w-full h-full"
    >
      <path className="stroke-black dark:stroke-white" d="M7 20H2l2.05-3.28A9 9 0 1 1 19.064 7" />
      <path className="stroke-blue-500" d="M15.5 22a6.5 6.5 0 1 1 5.02-2.37L22 22z" />
    </svg>
  );
}
